import React, { useState } from "react";

const API_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "") + "/api";

export default function Signup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [orgName, setOrgName] = useState("");
  const [status, setStatus] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus(null);
    console.log("[Signup] Submitting signup form", { name, email, orgName });
    try {
      const res = await fetch(`${API_BASE}/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, password, orgName }),
      });
      if (res.ok) {
        setStatus("Check your email to verify your account.");
        setName("");
        setEmail("");
        setPassword("");
        setOrgName("");
      } else {
        let data = {};
        try {
          data = await res.json();
        } catch (err) {
          console.error("[Signup] Failed to parse error JSON", err);
        }
        setStatus((data as any).error || `Signup failed: ${res.status} ${res.statusText}`);
        console.error("[Signup] Signup failed", data, res.status, res.statusText);
      }
    } catch (err) {
      setStatus("Network or server error");
      console.error("[Signup] Network/server error", err);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: "2rem auto" }}>
      <h2>Sign Up</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "0.5rem" }}>
          <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ width: "100%" }}
          />
        </div>
        <div style={{ marginBottom: "0.5rem" }}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: "100%" }}
          />
        </div>
        <div style={{ marginBottom: "0.5rem" }}>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: "100%" }}
          />
        </div>
        <div style={{ marginBottom: "0.5rem" }}>
          <input
            type="text"
            placeholder="Organization Name"
            value={orgName}
            onChange={(e) => setOrgName(e.target.value)}
            style={{ width: "100%" }}
          />
        </div>
        <button type="submit">Sign Up</button>
      </form>
      {status && <p style={{ marginTop: "1rem" }}>{status}</p>}
    </div>
  );
}
